'use client';

import { DocumentDownload } from 'iconsax-react';
import { X } from 'react-feather';

import { cn } from '@shared/lib';

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../modals';
import { ToastService } from '../toast';

type PreviewImageProps = {
  src: string;
  alt?: string;
  filename?: string;
  showDownload?: boolean;
  children?: React.ReactNode;
  className?: string;
};

export const PreviewImage = ({
  src,
  alt = '',
  filename = 'image.png',
  showDownload = true,
  children,
  className,
}: PreviewImageProps) => {
  const handleSaveImage = async () => {
    try {
      const response = await fetch(src);
      if (!response.ok) {
        throw new Error(`Image download failed: ${response.status}`);
      }
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(objectUrl);
    } catch {
      ToastService.error('دانلود تصویر با خطا مواجه شد');
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type='button'
          className={cn(
            'cursor-pointer border-none bg-transparent p-0 appearance-none',
            className
          )}
        >
          {children}
        </button>
      </DialogTrigger>
      <DialogContent className='flex h-screen max-w-full flex-col border-none bg-black/70 p-0 shadow-none sm:rounded-none'>
        <DialogHeader className='z-10 flex shrink-0 items-center justify-between border-none p-4 sm:p-6'>
          <DialogTitle className='text-[#d1d4dc]'>{alt || filename}</DialogTitle>
          <div className='flex max-h-[50px] items-center justify-end gap-1'>
            {showDownload && (
              <DocumentDownload
                className='cursor-pointer rounded-md p-1 text-[#d1d4dc] hover:bg-[#2f3241]'
                size={32}
                onClick={handleSaveImage}
              />
            )}
            <DialogClose className='text-text'>
              <X
                className='rounded-md p-1 text-[#d1d4dc] hover:bg-[#2f3241]'
                size={32}
                strokeWidth={1}
              />
            </DialogClose>
          </div>
        </DialogHeader>
        <div className='flex min-h-0 flex-1 items-center justify-center overflow-auto p-4 sm:p-6'>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={src}
            alt={alt}
            className='h-auto w-auto max-h-full max-w-full object-contain'
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
